import type { CasinoGame } from '@/types/casino';

export const CASINO_GROUPED_LIMIT = 3500;

export const normalizeCasinoCategoryKey = (value?: string) =>
  (value ?? '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '');

export const formatCasinoCategoryLabel = (value?: string) => {
  if (!value) return 'Others';

  return value
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const groupCasinoGamesByCategory = (games: CasinoGame[]) => {
  const groups = new Map<string, CasinoGame[]>();

  games.forEach((game) => {
    const key = formatCasinoCategoryLabel(game.category);
    groups.set(key, [...(groups.get(key) ?? []), game]);
  });

  return Array.from(groups.entries()).map(([title, groupedGames]) => ({
    title,
    games: groupedGames,
  }));
};
